import type { CreateHolder, HolderModel, UpdateHolder } from '@/types/tool.types';
import type { ToolSystem } from '@/types/toolSystem.types';
import { apiClient } from './client';

export const holdersApi = {
  /** GET /holders - list holders, optionally only those of one tool system. */
  getAll: async (toolSystem?: ToolSystem | null): Promise<HolderModel[]> => {
    const searchParams = new URLSearchParams();
    if (toolSystem != null) searchParams.set('tool_system', toolSystem);
    const query = searchParams.toString();
    const { data } = await apiClient.get<HolderModel[]>(query ? `/holders?${query}` : '/holders');
    return data;
  },

  /** POST /holders - create a new holder. */
  create: async (body: CreateHolder): Promise<{ uid: string }> => {
    const { data } = await apiClient.post<{ uid: string }>('/holders', body);
    return data;
  },

  /** PUT /holders/{holder_id} - update a holder. */
  update: async (holderId: string, body: UpdateHolder): Promise<HolderModel> => {
    const { data } = await apiClient.put<HolderModel>(`/holders/${holderId}`, body);
    return data;
  },

  /** DELETE /holders/{holder_id} - delete a holder. */
  delete: async (holderId: string): Promise<void> => {
    await apiClient.delete(`/holders/${holderId}`);
  },
};
